import type {
  SaveConfirmationDialogAction,
  SaveConfirmationDialogCopy,
  SaveConfirmationInvalidGame,
  SaveConfirmationInvalidPack,
  SaveConfirmationValidationAlertConfig,
} from '../../../../types/saveConfirmationDialogTypes';

export const buildSaveConfirmationCopy = (
  action: SaveConfirmationDialogAction,
  hasErrors: boolean,
): SaveConfirmationDialogCopy => {
  if (action === 'reject') {
    return {
      title: 'Confirm Rejection',
      heading: 'Please confirm that you want to reject this audit.',
      description:
        'Rejecting this audit will mark it as rejected and prevent it from being processed. You can review and make changes later if needed.',
      confirmLabel: 'Reject',
    };
  }

  return {
    title: 'Confirm Before Processing',
    heading: 'Please confirm that you have thoroughly reviewed all OCR data and game packs before processing.',
    description:
      'Once processed, these changes will be applied to the audit and the audit will be marked as completed.',
    confirmLabel: hasErrors ? 'Process Anyway' : 'Process',
  };
};

export const getSaveConfirmationButtonsDisabled = ({
  countdown,
  isRejectAction,
  saving,
  validating,
}: {
  countdown: number;
  isRejectAction: boolean;
  saving: boolean;
  validating: boolean;
}) => {
  return (!isRejectAction && countdown > 0 && !validating) || saving || validating;
};

export const buildInvalidGameText = (item: SaveConfirmationInvalidGame): string => {
  return `Game ${item.game}${item.pack ? ` - Pack ${item.pack}` : ''}${
    item.range ? ` (Range: ${item.range})` : ''
  }`;
};

export const buildInvalidPackText = (item: SaveConfirmationInvalidPack): string => {
  return `Game ${item.game} - Pack ${item.pack}${item.range ? ` (Range: ${item.range})` : ''}`;
};

export const invalidGamesAlertConfig: SaveConfirmationValidationAlertConfig = {
  severity: 'error',
  title: 'Invalid Games Detected',
  description:
    'The following games are not present in the store\'s active games list. These games need to be reviewed:',
};

export const invalidPacksAlertConfig: SaveConfirmationValidationAlertConfig = {
  severity: 'warning',
  title: 'Invalid Packs Detected',
  description:
    'The following packs are not present in the store\'s active packs for their respective games. Please verify these pack numbers:',
};
